import { FaCheck } from "react-icons/fa6";

import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
  title: string;
  onClick: () => void;
  isActive: boolean;
};

export const Option = (props: Props) => {
  const { className, onClick, title, isActive } = props;

  return (
    <li
      className={cn(
        "border-dark-grey flex cursor-pointer border-t px-4 py-3.5 transition-colors last:border-none hover:brightness-110",
        className
      )}
      onClick={onClick}
    >
      <div className="flex grow items-center justify-between">
        <div className="flex flex-col text-white">
          <span className="flex text-[17px] leading-5.5 tracking-[0.43px]">
            {title}
          </span>
        </div>
        {isActive && <FaCheck className="text-clear-blue size-5" />}
      </div>
    </li>
  );
};
